<script setup lang="ts">
import { ref, watch } from 'vue'
import { Button } from './ui/button'
import { Input } from './ui/input'

const props = defineProps<{
  modelValue?: [string | null, string | null]
  class?: any
}>()

const emits = defineEmits<{
  (e: 'onInputChange', value: [string | null, string | null]): void
}>()

const inputNumberLeft = ref<string>(props.modelValue[0] || '')
const inputNumberRight = ref<string>(props.modelValue[1] || '')

watch(
  () => props.modelValue,
  ([left, right]) => {
    inputNumberLeft.value = left?.toString() || ''
    inputNumberRight.value = right?.toString() || ''
  }
)

function onNumberInputLeft(e: Event) {
  const value = (e.target as HTMLInputElement).value

  emitNumberChange([value, props.modelValue[1]])
}
function onNumberInputRight(e: Event) {
  const value = (e.target as HTMLInputElement).value

  emitNumberChange([props.modelValue[0], value])
}
function onNumberInputExact(e: Event) {
  const value = (e.target as HTMLInputElement).value

  emitNumberChange([value, value])
}

function emitNumberChange([left, right]: [string, string]) {
  // Remove formatting to make it possible to convert to number.
  emits('onInputChange', [left.replace(/\s/g, ''), right.replace(/\s/g, '')])
}

const inputType = ref<'between' | 'exact'>('between')
</script>
<template>
  <div class="w-full flex items-center gap-2" v-if="inputType === 'between'">
    <div class="flex gap-2 w-full items-center bg-slate-50 border-slate-200 border rounded-md pl-2">
      <span class="shrink-0 font-semibold text-xs">Lowest value</span>
      <Input
        @input="onNumberInputLeft"
        :modelValue="inputNumberLeft"
        placeholder="10"
        class="bg-white border-y-0 border-r-0"
      />
    </div>
    <div class="flex gap-2 w-full items-center bg-slate-50 border-slate-200 border rounded-md pl-2">
      <span class="shrink-0 font-semibold text-xs">Highest value</span>
      <Input
        @input="onNumberInputRight"
        :modelValue="inputNumberRight"
        placeholder="100"
        class="bg-white border-y-0 border-r-0"
      />
    </div>
  </div>
  <div class="w-full flex items-center gap-2" v-else-if="inputType === 'exact'">
    <Input
      @input="onNumberInputExact"
      :modelValue="inputNumberLeft"
      placeholder="10"
      class="bg-white"
    />
  </div>
  <Button
    @click="inputType = inputType === 'exact' ? 'between' : 'exact'"
    variant="outline"
    class="text-xs ml-1"
  >
    {{ inputType === 'exact' ? 'Filter between values' : 'Filter exact value' }}
  </Button>
</template>
<style scoped>
::placeholder {
  color: #9ca3af;
  font-size: 0.875rem;
}
</style>
